var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component department-tree",staticStyle:{"display":"inline-block","min-width":"100%"}},[_c('data-tree',{ref:"orgTree",attrs:{"props":{title:'name'},"data":_vm.departmentData,"showCheckbox":_vm.showCheck},on:{"select-change":_vm.onCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }